export default __webpack_public_path__ + "media/images/tenant/howToRentApartment/step_3-7274379eda979aab2e9bf5445df2a0fe.webp";